module.exports = require("markdown-it-regex");


//////////////////
// WEBPACK FOOTER
// external "markdown-it-regex"
// module id = 3
// module chunks = 0